/**
 * Badge common utility
 * M-7: 배지 컴포넌트 공통 상수 통합
 */

export type BadgeSize = 'sm' | 'md' | 'lg';

export const BADGE_SIZE_CLASSES: Record<BadgeSize, string> = {
  sm: 'text-xs px-1.5 py-0.5',
  md: 'text-sm px-2 py-0.5',
  lg: 'text-sm px-2.5 py-1',
};

export const BADGE_ICON_SIZES: Record<BadgeSize, string> = {
  sm: 'h-3 w-3',
  md: 'h-3.5 w-3.5',
  lg: 'h-4 w-4',
};
